export const CREATE_ACTIVITY_STORY = 'CREATE_ACTIVITY_STORY'
export const CREATE_ACTIVITY_STORY_LOADING = 'CREATE_ACTIVITY_STORY_LOADING'
export const CREATE_ACTIVITY_STORY_ERROR = 'CREATE_ACTIVITY_STORY_ERROR'
export const CREATE_ACTIVITY_STORY_SUCCESS = 'CREATE_ACTIVITY_STORY_SUCCESS'

export const POST_STORY_COMMENT = 'POST_STORY_COMMENT'
export const POST_STORY_COMMENT_LOADING = 'POST_STORY_COMMENT_LOADING'
export const POST_STORY_COMMENT_ERROR = 'POST_STORY_COMMENT_ERROR'
export const POST_STORY_COMMENT_SUCCESS = 'POST_STORY_COMMENT_SUCCESS'

export const POST_STORY_IMAGE = 'POST_STORY_IMAGE'
export const POST_STORY_IMAGE_LOADING = 'POST_STORY_IMAGE_LOADING'
export const POST_STORY_IMAGE_ERROR = 'POST_STORY_IMAGE_ERROR'
export const POST_STORY_IMAGE_SUCCESS = 'POST_STORY_IMAGE_SUCCESS'

export const GET_ACTIVITY_FEED = 'GET_ACTIVITY_FEED'
export const GET_ACTIVITY_FEED_LOADING = 'GET_ACTIVITY_FEED_LOADING'
export const GET_ACTIVITY_FEED_SUCCESS = 'GET_ACTIVITY_FEED_SUCCESS'
export const GET_ACTIVITY_FEED_ERROR = 'GET_ACTIVITY_FEED_ERROR'

export const LIKE_STORY = 'LIKE_STORY'
export const LIKE_STORY_LOADING = 'LIKE_STORY_LOADING'
export const LIKE_STORY_SUCCESS = 'LIKE_STORY_SUCCESS'
export const LIKE_STORY_ERROR = 'LIKE_STORY_ERROR'

export const UNLIKE_STORY = 'UNLIKE_STORY'
export const UNLIKE_STORY_LOADING = 'UNLIKE_STORY_LOADING'
export const UNLIKE_STORY_SUCCESS = 'UNLIKE_STORY_SUCCESS'
export const UNLIKE_STORY_ERROR = 'UNLIKE_STORY_ERROR'

export const POST_COMMENT = 'POST_COMMENT'
export const POST_COMMENT_LOADING = 'POST_COMMENT_LOADING'
export const POST_COMMENT_SUCCESS = 'POST_COMMENT_SUCCESS'
export const POST_COMMENT_ERROR = 'POST_COMMENT_ERROR'

export const DELETE_COMMENT = 'DELETE_COMMENT'
export const DELETE_COMMENT_LOADING = 'DELETE_COMMENT_LOADING'
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS'
export const DELETE_COMMENT_ERROR = 'DELETE_COMMENT_ERROR'

export const DELETE_STORY = 'DELETE_STORY'
export const DELETE_STORY_LOADING = 'DELETE_STORY_LOADING'
export const DELETE_STORY_SUCCESS = 'DELETE_STORY_SUCCESS'
export const DELETE_STORY_ERROR = 'DELETE_STORY_ERROR'

export const GET_STORY_COMMENTS = 'GET_STORY_COMMENTS'
export const GET_STORY_COMMENTS_LOADING = 'GET_STORY_COMMENTS_LOADING'
export const GET_STORY_COMMENTS_SUCCESS = 'GET_STORY_COMMENTS_SUCCESS'
export const GET_STORY_COMMENTS_ERROR = 'GET_STORY_COMMENTS_ERROR'
